import React from "react";
import { Modal as RNModal } from "react-native";
import Toast from "react-native-toast-message";

import { ToastConfig } from "@components/Toast";

const Modal = ({
  children,
  animationType,
  transparent,
  visible,
  onRequestClose,
}) => {
  return (
    <RNModal
      animationType={animationType}
      transparent={transparent}
      visible={visible}
      onRequestClose={onRequestClose}
    >
      {children}
      <Toast config={ToastConfig} ref={(ref) => Toast.setRef(ref)} />
    </RNModal>
  );
};

export default Modal;
